import { DashboardHostRouteShell } from './DashboardHostRouteShell';
import SiteDashboardPage from './SiteDashboardPage';

// -- type definitions --

export interface ContextualDashboardRouteProps {
  readonly project_id: number;
  readonly site_id: number;
  readonly grid_id: number;
  readonly simplified_view?: boolean;
}

// -- main component --

/** Home-page or programmatic dashboard entry without URL route params. */
export default function ContextualDashboardRoute({
  project_id,
  site_id,
  grid_id,
  simplified_view = true,
}: ContextualDashboardRouteProps) {
  return (
    <DashboardHostRouteShell
      project_id={project_id}
      site_id={site_id}
      grid_id={grid_id}
      mode="site"
      grid_type="grids"
      simplified_view={simplified_view}
      dashboard_only_mode={false}
    >
      <SiteDashboardPage />
    </DashboardHostRouteShell>
  );
}
